import { z } from 'zod';
import { MARKET_ACTION_TIMEOUT_MS, MARKET_READ_TIMEOUT_MS } from '~/features/market/requestPolicy';
import { withRequestDeadline } from '~/utils/requestDeadline';
import { getData, postData } from '~/utils/service';
import { TERMS_DOCUMENT } from './platformParticipationAgreement';

export const TermsStatusSchema = z.object({
  documentCode: z.string(),
  currentVersion: z.string(),
  accepted: z.boolean(),
  acceptedAt: z.string().nullable(),
});

export type TermsStatus = z.infer<typeof TermsStatusSchema>;

// Both calls are bounded: a stalled read must reach the gate's retry state and a
// stalled save must give the dialog its buttons back.
export const getHlxTermsStatus = async (signal?: AbortSignal): Promise<TermsStatus> =>
  TermsStatusSchema.parse(
    await withRequestDeadline(
      (requestSignal) => getData('terms', { signal: requestSignal }),
      MARKET_READ_TIMEOUT_MS,
      signal
    )
  );

/** Record the HLX first-login acceptance of the version this build displays. */
export const acceptHlxTerms = async (signal?: AbortSignal): Promise<TermsStatus> =>
  TermsStatusSchema.parse(
    await withRequestDeadline(
      (requestSignal) =>
        postData('terms', {
          data: {
            documentCode: TERMS_DOCUMENT.code,
            version: TERMS_DOCUMENT.version,
            context: 'HLX_FIRST_LOGIN',
          },
          signal: requestSignal,
        }),
      MARKET_ACTION_TIMEOUT_MS,
      signal
    )
  );
